import { Droplet } from "lucide-react";
import FloatingTool from "./FloatingTool";

// ClinIV: se abre en ventana modal (reducida en escritorio, completa en móvil), sin salir del expediente.
export default function FloatingClinIV() {
  return (
    <FloatingTool
      src="/cliniv.html"
      title="ClinIV · Soluciones intravenosas"
      label="ClinIV"
      Icon={Droplet}
      colorClass="bg-[#0b5f73]"
      shadowClass="shadow-[#0b5f73]/30"
      bottomClass="bottom-40"
    />
  );
}
